import React, { useEffect, useState, Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { db } from '../firebase';
import { PriceGraph } from '../components/PriceGraph';
import { Layout } from '../components/Layout';
import { PriceEntry } from '../components/ArtworkPriceTracker';
export function ViewArtwork() {
  const {
    artworkName
  } = useParams<{
    artworkName: string;
  }>();
  const [artworkData, setArtworkData] = useState<PriceEntry[]>([]);
  const decodedArtworkName = artworkName ? decodeURIComponent(artworkName) : '';
  useEffect(() => {
    if (!decodedArtworkName) return;
    const artworkRef = ref(db, `artworks/${decodedArtworkName}`);
    const unsubscribe = onValue(artworkRef, snapshot => {
      const data = snapshot.val();
      if (data) {
        setArtworkData(data);
      }
    });
    return () => unsubscribe();
  }, [decodedArtworkName]);
  if (!decodedArtworkName || artworkData.length === 0) {
    return <Layout data-id="element-83">
        <div className="text-center py-12" data-id="element-84">
          <h1 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-85">
            Artwork Not Found
          </h1>
          <p className="text-gray-600 mb-6" data-id="element-86">
            The artwork you're looking for doesn't exist or has no data.
          </p>
          <Link to="/" className="text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-87">
            Return to Dashboard
          </Link>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-88">
      <div className="space-y-6" data-id="element-89">
        <div className="flex items-center justify-between" data-id="element-90">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800" data-id="element-91">
            {decodedArtworkName}
          </h1>
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-92">
            View All Artworks
          </Link>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg" data-id="element-93">
          <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-94">
            Value History
          </h2>
          <div className="overflow-auto" data-id="element-95">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-96">
              <thead className="bg-gray-50" data-id="element-97">
                <tr data-id="element-98">
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-99">
                    Year
                  </th>
                  <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-100">
                    Value Change
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-101">
                {artworkData.map(entry => <tr key={entry.id} data-id="element-102">
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-103">
                      {entry.year}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900" data-id="element-104">
                      {entry.price === 100 ? 'Baseline (100%)' : `${entry.price.toFixed(1)}%`}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg" data-id="element-105">
          <h2 className="text-lg font-medium text-gray-800 mb-3" data-id="element-106">
            Value Growth Trend
          </h2>
          <PriceGraph data={artworkData} artworkName={decodedArtworkName} data-id="element-107" />
        </div>
      </div>
    </Layout>;
}